<p-dialog
  data-testid="add-lot-dialog"
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '500px', maxWidth: '95vw' }"
  [header]="'inbound.receive.add_lot_number' | translate"
  (onHide)="onCancel()"
>
  <div class="p-4">
    @if (skuName) {
      <p class="text-sm font-medium text-gray-700 mb-4">
        {{ "inbound.fields.sku_name" | translate }}: {{ skuName }}
      </p>
    }

    <form data-testid="add-lot-dialog-form" [formGroup]="lotForm" class="space-y-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">
          {{ "inbound.fields.lot" | translate }}
          <span class="text-red-500">*</span>
        </label>
        <input
          data-testid="add-lot-dialog-lot-number-input"
          type="text"
          pInputText
          formControlName="lotNumber"
          [placeholder]="'inbound.receive.enter_lot_number' | translate"
          class="w-full"
          [class.p-invalid]="
            lotForm.get('lotNumber')?.invalid &&
            lotForm.get('lotNumber')?.touched
          "
        />
        @if (
          lotForm.get("lotNumber")?.invalid && lotForm.get("lotNumber")?.touched
        ) {
          <small class="text-red-500 text-xs mt-1 block">
            {{ "inbound.receive.lot_number_required" | translate }}
          </small>
        }
      </div>
    </form>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <app-button
        [testId]="'add-lot-dialog-cancel-btn'"
        [label]="'common.actions.cancel' | translate"
        type="secondary"
        [outlined]="true"
        (emitOnClick)="onCancel()"
      ></app-button>
      <app-button
        [testId]="'add-lot-dialog-confirm-btn'"
        [label]="'common.actions.confirm' | translate"
        type="info"
        (emitOnClick)="onConfirm()"
      ></app-button>
    </div>
  </ng-template>
</p-dialog>

<!-- Toast Messages -->
<p-toast data-testid="add-lot-dialog-toast"></p-toast>
